module.exports = __webpack_public_path__ + "assets/img/internet-m.391182c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/topics/internet-m.jpg
// module id = T8ql
// module chunks = 0